import React, { useState, useEffect } from 'react'
import {
  Card,
  Row,
  Col,
  Spin,
  Checkbox,
  Form,
  Input,
  Divider,
  Button,
  InputNumber,
  message
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import { useHistory } from 'react-router-dom'
import CKEditor from 'react-ckeditor-component'
import { ArrowLeftOutlined } from '@ant-design/icons'
import EqualsIcon from '../../../assets/images/equals-icon.png'
import ds from '../../../Services/DataServices'
import { useDispatch, useSelector } from 'react-redux'
import Loyalty from './Loyalty'
import {
  loadLoyaltyEnableDisable,
  setCommonConfigs
} from '../../../appRedux/actions/CommonData'
import Spinner from 'reactstrap/lib/Spinner'
import { LOYALTY_SCREEN } from '../../../constants/Pages'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { notAllowMsgCheck, verifyPkgFeature } from '../../../appRedux/actions'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const AddLoyalty = () => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const history = useHistory()

  const getIsEnableLoyalty = useSelector(
    ({ commonConfigs }) => commonConfigs.getIsLoyaltyEnable
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [confirmLoading, setConfirmLoading] = useState(true) // change state
  const [isEmailEnabled, setEmailEnabled] = useState(false)
  const [loader, setLoader] = useState(true)
  const [isLoyaltyEnabled, setLoyaltyEnabled] = useState(true)
  const [descriptionContent, setDescriptionContent] = useState('')
  const [loyaltyConfig, setloyaltyConfig] = useState(false)
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [getShortCurr, setShortCurr] = useState('')
  const [getIsDisable, setIsDisable] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [loyaltyValues, setLoyaltyValues] = useState({
    equalMoney: 10,
    emailSubject: 'Welcome to the Loyalty Program',
    loyaltyPoint: '1',
    loyaltyBonus: 5
  })
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)

  //rights & permissions
  React.useEffect(() => {
    let commonData = getReduxCommonSetting
    let rites = []
    let permissions = []
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig
    ) {
      if (commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission) {
        if (
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
            .rites &&
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
            .length > 0
        ) {
          rites =
            commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
              .rites
          setRights(rites)
        }
        if (
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
            .permission &&
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
            .permission.length > 0
        ) {
          permissions =
            commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
              .rites
          setPermissions(permissions)
        }
      }

      //curr
      if (commonData.storeCommonConfigs.storeConfig.currencyData) {
        let currencyData =
          commonData.storeCommonConfigs.storeConfig.currencyData
        setCurrSymbol(currencyData.currencySymbol)
        setShortCurr(currencyData.currencyCode)
      }
    }

    if (rites.length > 0) {
      if (rites.filter(a => a == READ).length > 0) {
        setIsAllowRead(true)
      }
      if (rites.filter(a => a == CREATE || a == UPDATE).length > 0) {
        setIsDisable(false)
      }
    }

    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false)
    }
  }, [getReduxCommonSetting])

  useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!verifyPkgFeature(PkgFeatures.InStoreLoyalty)) {
        setIsFeatureAllowed(false)
      }
      dispatch(setCommonConfigs(LOYALTY_SCREEN))
      getIsLoyaltyEnabled()
      getIsLoyaltyValuesService()
    }
    return () => {
      mounted = false
    }
  }, [])

  useEffect(() => {
    form.setFieldsValue({
      LoyaltyAmount: loyaltyValues.equalMoney,
      EmailSubject: loyaltyValues.emailSubject
      // EmailDesc: loyaltyValues.loyaltyMessage,
    })
  }, [loyaltyValues])

  async function getIsLoyaltyValuesService () {
    await ds
      .getLoyaltyValues('', BEHAVIOUR_TYPE.GET)
      .then(res => {
        if (res) {
          setLoyaltyValues({
            equalMoney: res.earnMoney,
            // loyaltyMessage: descriptionContent,
            emailSubject: res.emailSubject,
            // loyaltyBonus: res.loyaltyBonus,
            loyaltyPoint: res.loyaltyPoint
          })
          setDescriptionContent(res.emailMessage)
          setEmailEnabled(res.isSendEmail)
          if (res.loyaltyBonus && res.loyaltyBonus > 0) {
            setloyaltyConfig(true)
            form.setFieldsValue({ BonusLoyalty: res.loyaltyBonus })
          }
          //   console.log(res);
        }
        setConfirmLoading(false)
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoading(false)
      })
  }

  async function getIsLoyaltyEnabled () {
    await ds
      .getLoyaltyConfigs('', BEHAVIOUR_TYPE.GET)
      .then(res => {
        setLoader(false)
        if (res.data && res.data.toLowerCase().includes('true')) {
          dispatch(loadLoyaltyEnableDisable(true))
          setLoyaltyEnabled(true)
        } else if (res.data && res.data.toLowerCase().includes('false')) {
          dispatch(loadLoyaltyEnableDisable(false))
          // setLoyaltyEnabled(false);
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setLoader(false)
        // setConfirmLoading(false);
      })
  }

  async function UpdateLoyaltyConfigurations (values) {
    await ds
      .postLoyaltyConfigsService(
        {
          IsEnableLoyalty: isLoyaltyEnabled,
          IsSendEmail: isEmailEnabled,
          EarnMoney: values.LoyaltyAmount ? values.LoyaltyAmount : 10,
          EmailSubject: values.EmailSubject ? values.EmailSubject : '',
          EmailMessage: descriptionContent,
          LoyaltyBonus: loyaltyConfig ? values.BonusLoyalty : 0
        },
        BEHAVIOUR_TYPE.UPDATE
      )
      .then(res => {
        setConfirmLoading(false)
        if (res) {
          message.success('Saved Successfully')
          // dispatch(loadData(true));
          dispatch(loadLoyaltyEnableDisable(isLoyaltyEnabled))
        } else {
          message.error('Something went wrong...')
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoading(false)
      })
  }

  const OnChangeDescription = evt => {
    setDescriptionContent(evt.editor.getData())
    // form.setFieldsValue({ EmailDesc: evt.editor.getData() });
    // setDescriptionContent(evt.editor.getData());
  }

  const onFinish = values => {
    setConfirmLoading(true)
    UpdateLoyaltyConfigurations(values)
  }

  const onFinishFailed = errorInfo => {
    setConfirmLoading(false)
    message.warn('Kindly Attend to Missing Fields')
  }

  return getIsAllowRead && isFeatureAllowed ? (
    <>
      {!getIsEnableLoyalty ? (
        <>
          {loader ? (
            <Spinner
              style={{
                marginLeft: '44%',
                marginTop: '18%',
                width: '3rem',
                height: '3rem'
              }}
              color='primary'
            />
          ) : (
            <Loyalty isDisable={getIsDisable} />
          )}
        </>
      ) : (
        <Spin
          tip={<IntlMessages id='sell.cashlisting.cashloading' />}
          spinning={confirmLoading}
          size='large'
        >
          <div className='Content-wrapper Loyalty-pg'>
            <Row>
              <Col md={24} sm={24} xs={24}>
                <h1 className='mb-0'>
                  <IntlMessages id='setup.addloyalty.title' />
                </h1>
              </Col>
            </Row>

            <div>
              <Form
                {...formItemLayout}
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{
                  prefix: '86'
                }}
                className=''
                scrollToFirstError
                id='AddLoyaltyForm'
                name='AddLoyaltyForm'
              >
                <Row className='mt-4 mb-4'>
                  <Checkbox
                    onChange={() => setLoyaltyEnabled(!isLoyaltyEnabled)}
                    checked={isLoyaltyEnabled}
                    disabled={getIsDisable}
                  >
                    <label className='custom-font-weight-500 custom-font-color-black mb-0'>
                      <strong>
                        <IntlMessages id='setup.addloyalty.subTitle1' />
                      </strong>
                    </label>
                  </Checkbox>
                  <p className='mb-0'>
                    <IntlMessages
                      id='setup.addloyalty.enableDescription'
                      values={{
                        strong: chunks => <strong>{chunks}</strong>,
                        title: getShortCurr
                      }}
                    />
                  </p>
                </Row>

                <Col md={24} className='custom-center-data'>
                  <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                    <IntlMessages id='setup.addloyalty.earningTitle' />
                  </h2>
                  <Row className='align-items-center justify-content-center'>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <Form.Item
                        className={
                          'ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment mb-0'
                        }
                        name={'LoyaltyAmount'}
                        rules={[
                          {
                            required: true,
                            message: 'Required'
                          }
                        ]}
                      >
                        <InputNumber
                          type='number'
                          disabled={getIsDisable}
                          step={1}
                          size='large'
                          placeholder='Earn'
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4}>
                      <img src={EqualsIcon} alt='' />
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={8}>
                      <h2 className='mb-0'>
                        <strong>{`${getCurrSymbol} ${loyaltyValues.loyaltyPoint}`}</strong>
                      </h2>
                    </Col>
                  </Row>
                  <p className='mt-2'>
                    <IntlMessages id='loyalty.screen.spending' />{' '}
                    {`${getCurrSymbol} ${loyaltyValues.equalMoney} `}
                    <IntlMessages id='loyalty.screen.earns' />{' '}
                    {`${getCurrSymbol} ${loyaltyValues.loyaltyPoint} `}
                    <IntlMessages id='customerz.custable.col2' />.
                  </p>
                </Col>

                {/* <Divider className='mt-3 mb-4' />

                <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                  <IntlMessages id='setup.addloyalty.subTitle2' />
                </h2>

                <Row>
                  <Checkbox
                    checked={loyaltyConfig}
                    onChange={() => setloyaltyConfig(!loyaltyConfig)}
                  >
                    <label className='mb-0'>
                      <strong>
                        {' '}
                        <IntlMessages id='setup.addloyalty.checkboxbonus' />{' '}
                      </strong>
                    </label>
                  </Checkbox>
                </Row> */}

                {loyaltyConfig && (
                  <Row className='BonusLoyalty mt-3'>
                    <Col lg={24} md={24} sm={24} xs={24} className='p-0'>
                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment form-inner-pad-0'
                        name='BonusLoyalty'
                        help={
                          <strong>
                            <IntlMessages id='setup.addloyalty.title' />
                          </strong>
                        }
                      >
                        <InputNumber type='number' step={1} className='w-100' />
                      </Form.Item>
                    </Col>
                  </Row>
                )}

                <Divider className='mt-3 mb-4' />

                {/* <Row>
                  <Checkbox
                    onChange={() => setEmailEnabled(!isEmailEnabled)}
                    checked={isEmailEnabled}
                    disabled={getIsDisable}
                  >
                    <label className='custom-font-weight-500 custom-font-color-black'>
                      <strong>
                        {' '}
                        <IntlMessages id='setup.addloyalty.welcomeTitle' />
                      </strong>
                    </label>
                  </Checkbox>
                  <p>
                    {' '}
                    <IntlMessages id='setup.addloyalty.welcomeDesc' />{' '}
                  </p>
                </Row> */}

                {/* {isEmailEnabled && !getIsDisable && (
                  <>
                    <Col lg={24} md={24} sm={24} xs={24} className='p-0'>
                      <Form.Item
                        className={
                          'ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment form-inner-pad-0'
                        }
                        name={'EmailSubject'}
                        label={
                          <strong>
                            <IntlMessages id='setup.addloyalty.emailSubject' />
                          </strong>
                        }
                        rules={[
                          {
                            required: true,
                            message: 'Required'
                          }
                        ]}
                      >
                        <Input placeholder='Welcome to the Loyalty Program' />
                      </Form.Item>
                    </Col>

                    <Col lg={24} md={24} sm={24} xs={24} className='p-0'>
                      <Form.Item
                        className={
                          'ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment form-inner-pad-0'
                        }
                        name={'EmailDesc'}
                        label={
                          <strong>
                            <IntlMessages id='setup.addloyalty.emailMsg' />
                          </strong>
                        }
                      >
                        <CKEditor
                          activeClass='p10'
                          content={descriptionContent}
                          events={{
                            change: OnChangeDescription
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )} */}
              </Form>
            </div>

            <Divider className='mt-3 mb-4' />

            <Row justify='end'>
              <Col md={24} sm={24} xs={24}>
                <div className='pg-header-btn'>
                  <Form
                    {...formItemLayout}
                    form={form}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    initialValues={{
                      prefix: '86'
                    }}
                    className=''
                    scrollToFirstError
                    id='AddLoyaltyForm'
                    name='AddLoyaltyForm'
                  >
                    <Button
                      className='dk-btn-cancel'
                      type='primary'
                      onClick={() => history.push('/dashboard/main')}
                      // disabled={getIsDisable}
                      size='large'
                    >
                      <IntlMessages id='setup.general.cancelBtn' />
                    </Button>
                    <Button
                      className='dk-btn-add'
                      type='primary'
                      htmlType='submit'
                      disabled={getIsDisable}
                      size='large'
                    >
                      <IntlMessages id='setup.general.saveBtn' />
                    </Button>
                  </Form>
                </div>
              </Col>
            </Row>
          </div>
        </Spin>
      )}
    </>
  ) : (
    <NotAllowedComponent
      getAccessLoading={getAccessLoading}
      textType={!isFeatureAllowed ? 2 : 1}
    />
  )
}

export default AddLoyalty
